import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCreditCardDiscover = ({
    className = '',
    color = '#979797',
    height = 16,
    opacity = 1,
    title,
    width = 25,
}: Icon) => (
    <AccessibleSVG
        className={`icon-credit-card-discover ${className}`}
        height={height}
        opacity={opacity}
        title={title}
        viewBox="0 0 25 16"
        width={width}
    >
        <g fill="none" fillRule="evenodd">
            <rect height="15" rx="2" stroke={color} width="24" x=".5" y=".5" />
            <path
                d="M4.552148 8.366022c-.184185.167156-.4213.23936-.798114.23936H3.5975V6.618007h.156534c.376815 0 .604847.067666.798114.2432.201538.180248.321744.459346.321744.747578 0 .288815-.120206.577688-.321744.757237zm-.681205-2.256815h-.85654v3.004858h.852086c.452072 0 .779023-.107752 1.065828-.346705.340313-.28387.54214-.711913.54214-1.15427 0-.887155-.658933-1.503883-1.603515-1.503883zM5.743447 6.109207h.582113v3.004858h-.582113M7.750734 7.261847c-.349858-.130385-.452826-.216378-.452826-.378007 0-.189382.183317-.33344.434604-.33344.174698 0 .318042.07203.470816.242735l.304217-.40035c-.250825-.221265-.550934-.33373-.87829-.33373-.528084 0-.931566.36963-.931566.860276 0 .414895.188.626445.734712.825194.22861.080698.344826.134516.403193.171287.116446.076626.17493.18438.17493.31046 0 .243665-.192805.42362-.453.42362-.27778 0-.501532-.13952-.636026-.400814l-.375833.365382c.268236.395927.590848.572218 1.034823.572218.604732 0 1.03008-.40605 1.03008-.987112 0-.477673-.196622-.69411-.859836-.937717M8.794176 7.61309c0 .884074.690113 1.568757 1.57737 1.568757.250823 0 .46584-.049862.730432-.175534v-.689746c-.233297.23453-.439405.328902-.703824.328902-.58674 0-1.003643-.42816-1.003643-1.036685 0-.576465.42992-1.03162.977035-1.03162.277318 0 .488228.099082.730433.33786v-.689687c-.255337-.13027-.466246-.183913-.717128-.183913-.882744 0-1.590674.69853-1.590674 1.571666M15.823556 8.12765l-.797477-2.018443h-.6362l1.268292 3.0816h.313357l1.290447-3.0816h-.631514l-.806907 2.018444M17.526858 9.114065h1.652917v-.508683h-1.070572v-.811637h1.029616v-.5088h-1.029617v-.666938h1.070572v-.5088h-1.652917v3.004858M20.317045 7.492247h-.16955v-.910545h.178863c.363684 0 .56071.153658.56071.44608 0 .301673-.197026.464465-.570023.464465zm1.169375-.496232c0-.56291-.38474-.886808-1.057152-.886808h-.864753v3.004858h.58298v-1.20768h.0763l.805982 1.20768h.716838l-.9414-1.265745c.439694-.090415.681205-.392436.681205-.852305z"
                fill={color}
            />
            <path
                d="M12.916114 6.052887c-.87962 0-1.593277.691142-1.593277 1.544146 0 .90688.68265 1.584814 1.593277 1.584814.887892 0 1.588938-.686894 1.588938-1.56701 0-.87488-.69636-1.56195-1.588938-1.56195"
                fill={color}
                opacity=".5"
            />
        </g>
    </AccessibleSVG>
);

export default IconCreditCardDiscover;
